import api from '../services/api'

export default {
  auth(to, from, next) {
    const token = sessionStorage.getItem(process.env.VUE_APP_KEY_TOKEN)

    if (!token) {
      next('/login')
      return
    }

    let axios = api({ jwt: sessionStorage.getItem(process.env.VUE_APP_KEY_TOKEN) })
    axios.get('/user/checkuser', {
      headers: {
        Authorization: `Bearer ${JSON.parse(token)}`
      }
    })
      .then(() => { next() })
      .catch(() => {
        next('/login')
        sessionStorage.removeItem(process.env.VUE_APP_KEY_TOKEN)
        return
      })

  }
}
